import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useWakeLock from '../../hooks/useWakeLock';

/**
 * Provider global para manter o Wake Lock ativo 100% do tempo na aplicação
 * Previne que a tela entre em suspensão durante toda a sessão do usuário
 */

export function WakeLockProvider({ children }) {
  const { isWakeLockSupported, isWakeLockActive } = useWakeLock(true);

  useEffect(() => {
    console.log(
      'WakeLock',
      isWakeLockSupported ? 'Suportado ✅' : 'Não suportado ❌'
    );
  }, [isWakeLockSupported]);

  useEffect(() => {
    console.log(
      '☕️ Status Wake Lock:',
      isWakeLockActive ? 'Ativo' : 'Inativo'
    );
  }, [isWakeLockActive]);

  return children;
}

WakeLockProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default WakeLockProvider;
